var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearAttachedFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0Z",
    fill: "#101821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4189 15.0063C16.8099 15.3974 16.8099 16.0293 16.4189 16.4204C16.2239 16.6154 15.9679 16.7134 15.7118 16.7134C15.4558 16.7134 15.1998 16.6154 15.0048 16.4204L11.9999 13.4153L8.99492 16.4204C8.79991 16.6154 8.54393 16.7134 8.28795 16.7134C8.03178 16.7134 7.7758 16.6154 7.5808 16.4204C7.18987 16.0293 7.18987 15.3974 7.5808 15.0063L10.5859 12.0013L7.5808 8.99638C7.18987 8.60527 7.18987 7.97337 7.5808 7.58226C7.97191 7.19133 8.60381 7.19133 8.99492 7.58226L11.9999 10.5874L15.0048 7.58226C15.3959 7.19133 16.0278 7.19133 16.4189 7.58226C16.8099 7.97337 16.8099 8.60527 16.4189 8.99638L13.4138 12.0013L16.4189 15.0063Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAttachedFile);
export default __webpack_public_path__ + "static/media/clear-attached-file.7d9c25cb.svg";
export { ForwardRef as ReactComponent };